// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MenuBar.css */
.menu-bar {
    position: relative;
    height: 112px;
    background-color: #5b7f95;
  }
  
  .menu-button {
    position: absolute;
    top: 45px;
    left: 20px;
    cursor: pointer;
  }
  
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999; /* Ensure overlay is above everything else */
  }
  
  .menu-popup {
    position: fixed;
    top: 48px;
    left: 0;
    width: 500px;
    height: 1135px;
    background-color: #ffffff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 1000; /* Ensure popup is above overlay */
  }
  
  .menu-options {

  }
  
  .menu-option {
    height: 96px;
    line-height: 96px;
    font-weight: bold;
    font-size: 24px;
    display: flex; /* 使用 flex 布局 */
    align-items: center; /* 垂直居中对齐 */
    padding-left: 20px; /* 左侧空白距离 */
  }
  
  .menu-option img {
    margin-right: 20px; /* 图标与文字之间的右侧间距 */
  }
  
  .menu-option span {
    position: absolute;
    left: 100px;
    justify-content: flex-start; /* 左对齐 */
  }
  


  .menu-option:hover {
    background-color: #f0f0f0; /* Highlight on hover */
  }
  
  .menu-overlay {
    position: fixed;

    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明灰色 */
    z-index: 999; /* 确保遮罩层在最顶层 */
  }

  
  .menu-option.selected {
    background-color: #ddeeff; /* 选中项的背景色 */
  }
  .menu-icon {
    margin-right: 20px; /* 调整图标和文字之间的距离 */
  }

  .selected-menu-item {
    position: absolute;
    top: 35px;
    left: 100px; /* 菜单图标的宽度加上间距 */
    font-size: 36px;
    color: white;
  }

`, "",{"version":3,"sources":["webpack://./src/css/MenuBar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,YAAY,EAAE,4CAA4C;EAC5D;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,uCAAuC;IACvC,aAAa,EAAE,kCAAkC;EACnD;;EAEA;;EAEA;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,aAAa,EAAE,eAAe;IAC9B,mBAAmB,EAAE,WAAW;IAChC,kBAAkB,EAAE,WAAW;EACjC;;EAEA;IACE,kBAAkB,EAAE,iBAAiB;EACvC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,2BAA2B,EAAE,QAAQ;EACvC;;;;EAIA;IACE,yBAAyB,EAAE,uBAAuB;EACpD;;EAEA;IACE,eAAe;;IAEf,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,UAAU;IAChD,YAAY,EAAE,cAAc;EAC9B;;;EAGA;IACE,yBAAyB,EAAE,YAAY;EACzC;EACA;IACE,kBAAkB,EAAE,iBAAiB;EACvC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAE,gBAAgB;IAC7B,eAAe;IACf,YAAY;EACd","sourcesContent":["/* MenuBar.css */\r\n.menu-bar {\r\n    position: relative;\r\n    height: 112px;\r\n    background-color: #5b7f95;\r\n  }\r\n  \r\n  .menu-button {\r\n    position: absolute;\r\n    top: 45px;\r\n    left: 20px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    z-index: 999; /* Ensure overlay is above everything else */\r\n  }\r\n  \r\n  .menu-popup {\r\n    position: fixed;\r\n    top: 48px;\r\n    left: 0;\r\n    width: 500px;\r\n    height: 1135px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\r\n    z-index: 1000; /* Ensure popup is above overlay */\r\n  }\r\n  \r\n  .menu-options {\r\n\r\n  }\r\n  \r\n  .menu-option {\r\n    height: 96px;\r\n    line-height: 96px;\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n    display: flex; /* 使用 flex 布局 */\r\n    align-items: center; /* 垂直居中对齐 */\r\n    padding-left: 20px; /* 左侧空白距离 */\r\n  }\r\n  \r\n  .menu-option img {\r\n    margin-right: 20px; /* 图标与文字之间的右侧间距 */\r\n  }\r\n  \r\n  .menu-option span {\r\n    position: absolute;\r\n    left: 100px;\r\n    justify-content: flex-start; /* 左对齐 */\r\n  }\r\n  \r\n\r\n\r\n  .menu-option:hover {\r\n    background-color: #f0f0f0; /* Highlight on hover */\r\n  }\r\n  \r\n  .menu-overlay {\r\n    position: fixed;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5); /* 半透明灰色 */\r\n    z-index: 999; /* 确保遮罩层在最顶层 */\r\n  }\r\n\r\n  \r\n  .menu-option.selected {\r\n    background-color: #ddeeff; /* 选中项的背景色 */\r\n  }\r\n  .menu-icon {\r\n    margin-right: 20px; /* 调整图标和文字之间的距离 */\r\n  }\r\n\r\n  .selected-menu-item {\r\n    position: absolute;\r\n    top: 35px;\r\n    left: 100px; /* 菜单图标的宽度加上间距 */\r\n    font-size: 36px;\r\n    color: white;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
